import React, { Component } from 'react'
import InfoItems from './InfoItems.jsx'
import Disclaimer from './Disclaimer'
import { uniq, flatten } from "lodash"
import { getFlatDataFromTree } from 'react-sortable-tree'
class InfoPage extends Component {
    state = {
            confirmedBoxes: 0,
            infoCollection: {},
            itemSteps: {},
            activatedButton: false,
            normalizedSteps: {}
    }

    isEmpty = (object) => {
        let isEmpty = true
        for (var key in object) {
            if (key) {
                isEmpty = false
            }
        }
        return isEmpty;
    }


    componentDidMount() {
        let infoPage = this.props.infoPage ? this.props.infoPage : {}
        let emptyInfoPage = this.isEmpty(infoPage)
        let infoCollection = this.state.infoCollection
        let normalizedSteps = {}
        let steps = getFlatDataFromTree({
            treeData: this.props.workInstruction.steps,
            getNodeKey: (({ node }) => node._id),
            ignoreCollapsed: false,
        }).map(node => {
            return node.node
        });

        steps.forEach(step => {
            normalizedSteps[step._id] = step
        })

        let itemSteps = {}
        if (!emptyInfoPage){
            for (let infoItem in infoPage) {
                let category = infoPage[infoItem].category
                itemSteps[infoItem] = infoPage[infoItem].steps.map(stepId => {
                    let iterStep = normalizedSteps[stepId]
                    return iterStep ? iterStep.title : ""
                })
                if (!category) {
                    category = "Untitled"
                }
                    if (infoCollection[category]) {
                        //lodash merges array without duplicates
                        infoCollection[category] = uniq(infoCollection[category].concat(infoItem))
                    } else {
                        infoCollection[category] = [infoItem]
                    }   
            }
        }        
        // example info collection
        // {
        //  Cautions: ["Verify your decal placement to avoid the paint job being rejected.", "5000 degree liquids", "Make sure you read all of these!"],
        //  Notes:    ["Test Notes"],
        //  Warnings: ["Warning #1 - Be Careful", "Warning #2 - Watch Out", "Warning #3", "Danger!", "Sharp! Touch and you will regret it!"],
        // }

        this.setState({
            normalizedSteps,
            infoCollection,
            totalCheckBoxes: flatten(Object.values(infoCollection)).length,
            emptyInfoPage,
            itemSteps
        })
    }

    toggleBox = (isSelected) => {
        
        if (isSelected) {
            this.setState(prevState => ({
                confirmedBoxes: prevState.confirmedBoxes + 1
            }));
        } else {
            this.setState(prevState => ({
                confirmedBoxes: prevState.confirmedBoxes - 1
            }));
        }
    }

    render = () => {
        let infoItems
        if (this.state.infoCollection && !this.state.emptyInfoPage) {
            infoItems = <InfoItems infoCollection={this.state.infoCollection} itemSteps={this.state.itemSteps} 
                                    activatedButton={this.state.activatedButton} activateButton={() => this.setState({activatedButton: true})} 
                        />
        }

        return <div id="wi-info-page-container" className="flex-column shadow">
            {this.state.emptyInfoPage ? this.props.confirmWarnings(): null}
            <div id="confirmation-columns-container" className="max-width overflow flex-evenly">
                {infoItems}
            </div>

            <div id="disclaimer-container">
                
                {this.state.activatedButton || !this.props.requireInfoChecks ? 
                    <Disclaimer content={`Before proceeding, please be sure to have the neccessary PPE and tools required to complete the work instruction. If
                    at any time you are unsure what might be needed for a step, please click on the step info icon to view all pertinent info items. Thank You`}/>
                    : 
                    <Disclaimer content="Please read and click each alert to continue." />
                }
                    {this.state.activatedButton || !this.props.requireInfoChecks ?
                    <div id="wi-info-page-button-container" className=" flex-justify-center max-width">
                        <button id="info-page-button" className="clickable button" onClick={this.props.confirmWarnings}>Continue</button>
                    </div> 
                        : null
                    }
            </div>
        </div>
    }
}

export default InfoPage